import type { GetStaticPaths, GetStaticProps } from "next"
import {
  getFeedArchive,
  getFeedPageParams,
  type TeaserArchiveProps,
} from "@/components/resources/data/archives"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"
import { parsePageParam } from "@/components/resources/utils/pagination"

const Resources = (props: TeaserArchiveProps) => <CategoryArchive {...props} />

Resources.getLayout = SiteLayout

export default Resources

// Blocking fallback: newsletter issues can add a page between deploys
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: (await getFeedPageParams()).map((n) => ({ params: { n } })),
  fallback: "blocking",
})

export const getStaticProps: GetStaticProps<TeaserArchiveProps, { n: string }> = async ({
  params,
}) => {
  const page = parsePageParam(params?.n)
  const props = page ? await getFeedArchive(page) : null
  // The 404 revalidates too: a Beehiiv outage only shortens the list for a while
  return props ? { props, revalidate: 180 } : { notFound: true, revalidate: 180 }
}
